module.exports = __webpack_public_path__ + "images/emoji/open_mouth.3ea05566a661e80a0855.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/open_mouth.png
// module id = mMKc
// module chunks = 13